import { render, staticRenderFns } from "./tab.vue?vue&type=template&id=8dfdd0d2&scoped=true"
import script from "./tab.vue?vue&type=script&lang=js"
export * from "./tab.vue?vue&type=script&lang=js"
import style0 from "@/assets/css/page.css?vue&type=style&index=0&id=8dfdd0d2&prod&scoped=true&lang=css&external"
import style1 from "./tab.vue?vue&type=style&index=1&id=8dfdd0d2&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "8dfdd0d2",
  null
  
)

export default component.exports